import type { HTMLAttributes, PropsWithChildren } from "react";
import { Children } from "react";

import { css } from "@compiled/react";

import { Adg4TabFC, mapChild } from "./tab-helper";
import { useAdg4TabsContext } from "./tabs";

/**
 * @deprecated - Please use @/libraries/design/patterns/tabs instead
 */
export type Adg4TabPanelProps = PropsWithChildren<{
    forceRender?: boolean;
    keepInDom?: boolean;
    panelIndex?: number;
}> &
    HTMLAttributes<HTMLDivElement>;

const hidePanelStyle = css({
    display: "none"
});

/**
 * @deprecated - Please use @/libraries/design/patterns/tabs instead
 */
const Adg4TabPanel: Adg4TabFC<Adg4TabPanelProps> = ({
    forceRender,
    keepInDom,
    children,
    panelIndex,
    id,
    ...props
}: Adg4TabPanelProps) => {
    const { isCurrentTab } = useAdg4TabsContext();

    const isTabSelected = isCurrentTab(panelIndex);
    const activeClass = isTabSelected ? "active-panel" : "";

    children = forceRender || isTabSelected || keepInDom ? children : null;

    return (
        <div
            {...props}
            css={[!isTabSelected && !forceRender && hidePanelStyle]}
            id={`panel${id}`}
            aria-labelledby={`tab${id}`}
            aria-hidden={!isTabSelected}
            role="tabpanel"
            className={["tab-panel", activeClass].join(" ")}
        >
            {Children.map(children, (child) => {
                return mapChild(child, { isPanelActive: isTabSelected });
            })}
        </div>
    );
};
Adg4TabPanel.tabsRole = "Adg4TabPanel";

export { Adg4TabPanel };
